import React from  'react';
import RowConfigSelect from "./RowConfigSelect";

const RowConfigRow = (props) =>
{
    // IMPORTANT!!!
    // moduleData is passed from RowConfigStep SORTED in the correct order
    // rowData is ALSO sorted in the same order, so rowData[0] corresponds to the module in moduleData[0]
    const label = props.rowData[0].name ? props.rowData[0].name.replaceAll('_', ' '): "";
    const name = props.rowData[0].module_catalog_key + ' - ' + label;
    const side = props.side ? props.side : null;
    const elementId = props.isElement ? props.elementId : null;
    const rows = props.rowData.map((row, i) =>  <td key={label + "-" + i}>{ <RowConfigSelect onBlur={props.onBlur} setLeft={(posX) => props.setLeft(posX)} setMessage={(message) => props.setMessage(message)} data={row} id={i} module={props.moduleData[i]} side={side} elementId={elementId} isElement={props.isElement}/>}</td>);

    return (
        <tr key={label + '-row'}>
            <th key={label + '-head'}>{name}</th>
            {rows}
        </tr>
    );
};

export default RowConfigRow